import React, { useEffect } from 'react';
import { Row, Divider, Button } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import QRCodeBox from 'RKSV/components/views/QRCodeBox';
import {
  useGenerateInitialReceipt,
  useInitialReceipt,
} from 'RKSV/hooks/settings';
import { handleErrorNotification } from 'Common/utils';
import Loading from 'Common/Components/Loading';
import { InitialReceipt } from 'utils/apiClient/services/rksv/types';

const EmptyQrCode = styled.div`
  width: 200px;
  height: 200px;
  border: solid 1px rgba(0, 0, 0, 0.25);
`;

const InitReceiptContainer = () => {
  const intl = useIntl();
  const { data, error, isLoading } = useInitialReceipt();
  const generateInitialReceiptMutation = useGenerateInitialReceipt();
  useEffect(() => {
    if (error) {
      handleErrorNotification({
        error,
        lang: intl.locale.toLowerCase(),
      });
    }
  }, [error]);

  return (
    <>
      <Row justify="space-between" css="padding: 1em">
        <h3 css="margin: 0; line-height: 32px">
          <FormattedMessage defaultMessage="Initial Receipt" />
        </h3>
        <Button
          type="primary"
          disabled={isLoading}
          onClick={() => generateInitialReceiptMutation.mutate()}
        >
          <FormattedMessage defaultMessage="Generate" />
        </Button>
      </Row>
      <Divider css="margin: 0" />
      <Row justify="center" css="padding: 30px">
        {isLoading && (
          <div css="height: 210px">
            <Loading noText verticallyCentered />
          </div>
        )}
        {!(data as InitialReceipt) && !isLoading && <EmptyQrCode />}
        {data?.ftSignatures && <QRCodeBox ftSignatures={data.ftSignatures} />}
      </Row>
    </>
  );
};

export default InitReceiptContainer;
